import { gql } from '@grandvisionhq/graphql';

const VALIDATE_ACCOUNT = gql`
  mutation ValidateCustomerAccount($input: ValidateAccountInput!) {
    validateCustomerAccount(input: $input) {
      ... on AccountValidatedSuccessfully {
        customerId
      }
      ... on AccountValidationMaxRetriesError {
        retries
      }
    }
  }
`;

export { VALIDATE_ACCOUNT };
//# sourceMappingURL=validate-account.js.map
